<!-- @format -->

<ng-container *transloco="let t">
  <div class="row">
    <div class="offset-md-1 col-md-10 offset-lg-2 col-lg-8">
      <app-extension-application-study-progress-and-plan-info
        [automaticallyFilledApplicationFields]="filledExtensionApplication"
        [attainedCreditsByStudyTerm]="planData.attainedCreditsByStudyTerm"
        [creditsPerTerm]="planData.creditsPerTerm"
        [plannedStudies]="planData.plannedStudies" />

      <fudis-heading [level]="2">{{ t("STUDENT_APPLICATIONS.EXTENSION_APPLICATION.APPLIED_EXTENSION") }}</fudis-heading>
      <fudis-dl [classes]="'fudis-mb-md'">
        <fudis-dl-item>
          @let terms = filledExtensionApplication.requestedTerms;
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.EXTENSION_APPLICATION.APPLIED_EXTENSION')" />
          <fudis-dd [contentText]="terms + ' ' + t(terms === 1 ? 'PROFILE.EXTENSIONS.SEMESTER' : 'PROFILE.EXTENSIONS.SEMESTERS')" />
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.EXTENSION_APPLICATION.DELAY_RATIONALE')" />
          <fudis-dd [contentText]="filledExtensionApplication.delayRationale" />
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.EXTENSION_APPLICATION.APPLICATION_RATIONALE')" />
          <fudis-dd [contentText]="filledExtensionApplication.applicationRationale" />
        </fudis-dl-item>
      </fudis-dl>

      <fudis-body-text [variant]="'lg-light'" class="fudis-mb-xxl">
        <transloco
          [key]="
            'PROFILE.APPLICATIONS.' +
            (filledExtensionApplication.mustPrintDecision ? 'DECISION_REQUESTED_BY_MAIL' : 'DECISION_NOT_REQUESTED_BY_MAIL')
          " />
      </fudis-body-text>

      <sis-button [hollow]="true" (clicked)="previous.emit()">
        <sis-icon icon="back" />
        {{ t("BUTTON.RETURN") }}
      </sis-button>
      <sis-button (clicked)="continue.emit()">
        {{ t("BUTTON.CONTINUE") }}
      </sis-button>
    </div>
  </div>
</ng-container>
